import React, { useEffect, useState, useRef, useContext } from "react";
import {
  get_rm_order_returnlist,
  postGeneralData,
  UpdatePaymentComplete,
  getCustomers,
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import { Pagination } from "../../Common/Functions";
import { WarehouseContext } from "../../../Utility/UserContext";
import {
  company_logo,
  getFormattedCurrentDate2,
  onReqCreatePayment,
} from "../../../Utility/function";

const rolesPerPage = 10;

const RMReturnListorder = () => {
  const { showLoader, hideLoader, shopItem, UserItem } =
    useContext(WarehouseContext);
  const [user] = useState(UserItem);
  const [returnList, setReturnList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [detailData, setDetailData] = useState(null);
  const [pamentsModel, setpamentsModel] = useState(false);
  const [Paymentvalue, setPaymentvalue] = useState();
  const [payAmount, setPayAmount] = useState(0);
  const modalContentRef = useRef();

  const [customers, setCustomers] = useState([]);

  const [companyInfo, setCompanyInfo] = useState({
    name: "Company Name",
    address: "123 Business Street, City, State 12345",
    phone: "(123) 456-7890",
    email: "info@yourcompany.com",
  });

  useEffect(() => {
    if (shopItem) {
      setCompanyInfo({
        name: shopItem?.title || "",
        address: shopItem?.Address || "123 Business Street, City, State 12345",
        phone: shopItem?.phone1 || "",
        email: shopItem?.email || "",
      });
    }
  }, [shopItem]);

  const fetchReturnList = async () => {
    try {
      const response = await get_rm_order_returnlist();
      if (response?.data?.data) {
        setReturnList(response.data.data);
        setTotalPages(Math.ceil(response.data.data.length / rolesPerPage));
      } else {
        toast.error("Failed to fetch RM return list.");
      }
    } catch (error) {
      console.error("Error fetching RM return list:", error);
      toast.error("Something went wrong while fetching RM return list.");
    }
  };

  const fetchCustomers = async () => {
    try {
      const res = await getCustomers();
      if (res?.data?.data) {
        setCustomers(res.data.data);
      }
    } catch (err) {
      console.error("Error fetching customers:", err);
    }
  };

  useEffect(() => {
    fetchReturnList();
    fetchCustomers();
  }, []);

  const handleView = (item) => {
    try {
      const parsedReturnData = JSON.parse(item.return_data || "[]");
      let parsedInvoiceData = [];
      try {
        if (item.invoice_number) {
          parsedInvoiceData = JSON.parse(item.invoice_number);
        }
      } catch (err) {
        console.warn("Failed to parse invoice_number:", err);
      }

      let allItems = [];

      if (Array.isArray(parsedInvoiceData) && parsedInvoiceData.length > 0) {
        parsedInvoiceData.forEach((entry) => {
          allItems.push({
            invoice_no: entry.unique_id || item.unique_id,
            product_name: entry.product_name,
            serial_number: entry.qty ? `Qty: ${entry.qty} kg` : "-",
            amount: parseFloat(entry.price || 0).toFixed(2),
          });
        });
      }

      if (allItems.length === 0) {
        allItems = parsedReturnData.flatMap((entry) => {
          const qty = entry.returnqty || entry.qty || 1;
          return [
            {
              invoice_no: entry.unique_id || item.unique_id,
              product_name: entry.product_name || `RM #${entry.raw_mat_id || ""}`,
              serial_number: `Qty: ${qty} kg`,
              amount: parseFloat(entry.amount || 0).toFixed(2),
            },
          ];
        });
      }

      const custId =
        parsedReturnData[0]?.supplier_id ||
        parsedReturnData[0]?.customer_id ||
        item?.customer_id;
      const foundCustomer = customers.find((c) => String(c.customer_id) === String(custId));
      const customerName =
        foundCustomer?.name || parsedReturnData[0]?.customer_name || "Walk-in Customer";

      setDetailData({
        return_id: item.unique_id,
        date: item.create_date?.split("T")[0],
        customer_name: customerName,
        items: allItems,
      });

      setShowModal(true);
    } catch (e) {
      console.error("Return data parse error:", e);
      toast.error("Invalid return data format");
    }
  };

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);
  const handleCloseModal = () => setShowModal(false);

  const dueAmount = parseFloat(Paymentvalue?.remaining || 0);
  const totalPayment = parseFloat(payAmount || 0);
  const remainingAmount = dueAmount - totalPayment;

  const onHandlepPayment = async (item) => {
    setPayAmount(0);
    setPaymentvalue(item);
    setpamentsModel(true);
  };

  const onHandlePayCredit = async (cashAmount) => {
    try {
      showLoader();
      if (!Paymentvalue?.unique_id) {
        toast.error("Invalid return details");
        hideLoader();
        return;
      }

      var paydata = {
        orderID: Paymentvalue?.unique_id,
        date: getFormattedCurrentDate2(),
        amount: "0",
        total_amount: Paymentvalue.amount,
        cash: 0,
        credit: 0,
        card: 0,
        type: 5, // sales return refund
        mop: "0",
        complete: "0",
      };

      if (cashAmount) {
        paydata.cash = cashAmount;
        paydata.mop = "1";
        paydata.complete = "1";
      }

      if (remainingAmount > 0) {
        paydata.credit = remainingAmount;
        paydata.mop = paydata.mop + ",2";
        paydata.complete = "0";
      }

      await onReqCreatePayment(paydata);

      try {
        const bankPayload = {
          type: "2",
          ref_id: Paymentvalue?.unique_id,
          remarks: "Bank Payment From RM Sales Refund",
          date: getFormattedCurrentDate2(),
          created_by: user?.user_id,
          shop_id: shopItem?.id || "0",
          amount: parseFloat(cashAmount || 0),
          is_debit: "0",
        };
        await postGeneralData(bankPayload);

        if (paydata?.complete == "0") {
          const generalDataPayload = {
            type: "12",
            ref_id: Paymentvalue?.unique_id,
            remarks: "RM Sales Return Credit",
            date: getFormattedCurrentDate2(),
            created_by: user?.user_id,
            shop_id: shopItem?.id || "0",
            amount: remainingAmount,
            is_debit: "0",
          };
          await postGeneralData(generalDataPayload);
        } else {
          const paymentCompleted = {
            type: "12",
            shop_id: shopItem?.id || "0",
            ref_id: Paymentvalue?.unique_id,
          };
          await UpdatePaymentComplete(paymentCompleted);
        }
      } catch (e) {
        console.error("General log failed:", e);
        toast.error("Failed to create general transaction log");
      }

      toast.success("Payment successfully");
      await fetchReturnList();
      setpamentsModel(false);
      setPayAmount(0);
      hideLoader();
    } catch (error) {
      console.error("Error updating payment:", error);
      toast.error("Error processing payment. Please try again.");
      hideLoader();
    }
  };

  return (
    <div className="page-wrappers">
      <div className="page-content">
        {/* Header */}
        <div className="mb-4 d-flex justify-content-between align-items-center bg-white p-3 rounded-2xl border border-slate-100 shadow-sm">
          <div className="text-start">
            <h3 className="mb-1 fw-bold text-slate-800 tracking-tight" style={{ fontSize: "24px" }}>
              RM Sales Return List
            </h3>
            <p className="text-sm text-slate-500 mb-0 font-medium">Record and manage customer RM sales returns</p>
          </div>
        </div>

        {/* List Table Card */}
        <div className="card border-0 shadow-sm rounded-2xl">
          <div className="card-body p-4">
            <div className="table-responsive" style={{ overflow: "visible" }}>
              <table
                className="table table-hover table-align-middle text-center mb-4"
                style={{ width: "100%", fontFamily: "Poppins" }}
              >
                <thead className="table-light">
                  <tr>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">S.No</th>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Return ID</th>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Amount (INR)</th>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Action</th>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Payment</th>
                  </tr>
                </thead>
                <tbody>
                  {returnList.length > 0 ? (
                    returnList
                      .slice((currentPage - 1) * rolesPerPage, currentPage * rolesPerPage)
                      .map((item, index) => (
                        <tr key={item.id} className="align-middle border-bottom border-slate-100">
                          <td className="text-sm font-semibold text-slate-700 py-3">
                            {(currentPage - 1) * rolesPerPage + index + 1}
                          </td>
                          <td className="text-sm font-semibold text-slate-700">{item.unique_id}</td>
                          <td className="text-sm font-semibold text-slate-700">
                            {parseFloat(item.amount).toFixed(2)} INR
                          </td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-primary btn-sm px-3"
                              onClick={() => handleView(item)}
                            >
                              View
                            </button>
                          </td>
                          <td>
                            {item?.status == "1" ? (
                              <button
                                type="button"
                                className="btn btn-warning btn-sm px-3 text-white font-semibold"
                                onClick={() => onHandlepPayment(item)}
                              >
                                Pay
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-success btn-sm px-3"
                                disabled
                              >
                                Refunded
                              </button>
                            )}
                          </td>
                        </tr>
                      ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center text-slate-400 py-4">
                        No return orders found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </div>

        {/* View Detail Modal */}
        {showModal && detailData && (
          <div
            className={`modal fade ${showModal ? "show" : ""}`}
            tabIndex={-1}
            role="dialog"
            style={{ display: showModal ? "block" : "none" }}
            aria-hidden={!showModal}
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div ref={modalContentRef}>
                  <div className="modal-header border-0 pb-0">
                    <button
                      type="button"
                      className="btn-close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={handleCloseModal}
                    ></button>
                  </div>

                  <div className="row mx-3 mt-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="col-md-1">
                        <img
                          src={company_logo || "/assets/images/ztr_masala_logo.jpg"}
                          alt="Left Logo"
                          style={{ maxHeight: "38px" }}
                        />
                      </div>
                    </div>
                    <div className="col-12 text-center mt-2">
                      <p className="fw-bold font-14 mb-0">{companyInfo?.address}</p>
                      <p className="fw-medium font-13 mb-0">
                        Mobile: {companyInfo?.phone} | Email: {companyInfo?.email}
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col text-center">
                      <h3 className="fw-bold mt-2" style={{ textDecoration: "underline" }}>
                        RETURN ORDER INVOICE
                      </h3>
                    </div>
                  </div>

                  <div className="container px-4 text-start">
                    <div className="row border-bottom pb-2">
                      <div className="col-6">
                        <strong>Return ID:</strong> {detailData.return_id}
                      </div>
                      <div className="col-6 text-end">
                        <strong>Date:</strong> {detailData.date}
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-6">
                        <strong>Customer:</strong> {detailData.customer_name}
                      </div>
                    </div>
                  </div>

                  {detailData?.items?.length > 0 ? (
                    <div className="container mt-2">
                      <table className="table table-bordered text-center align-middle">
                        <thead className="bg-dark text-white">
                          <tr>
                            <th>S.No</th>
                            <th>Invoice No</th>
                            <th>Product</th>
                            <th>Serial</th>
                          </tr>
                        </thead>
                        <tbody>
                          {detailData.items.map((data, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>{data.invoice_no}</td>
                              <td className="text-start">{data.product_name}</td>
                              <td>{data.serial_number}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="text-center text-muted py-4">No return items found.</div>
                  )}

                  <div className="modal-footer mx-1 mt-4">
                    <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Pay Credit Modal */}
        {pamentsModel && Paymentvalue && (
          <div
            className="modal fade show"
            style={{ display: pamentsModel ? "block" : "none" }}
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div
                className="modal-content p-3"
                style={{
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                }}
              >
                {/* Modal Header */}
                <div className="modal-header border-0">
                  <h5 className="modal-title fw-bold text-dark font-18">Payment</h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => setpamentsModel(false)}
                  ></button>
                </div>

                {/* Modal Body */}
                <div className="modal-body">
                  <div className="p-3 bg-light rounded text-start">
                    <p className="mb-2">
                      Order ID: <span className="fw-bold">{Paymentvalue?.unique_id}</span>
                    </p>
                    <p className="mb-2">
                      <span>Supplier Name:</span>
                      <span className="fw-bold">{Paymentvalue?.supplier_name}</span>
                    </p>
                    <hr />
                    <div>
                      <p className="mb-2 d-flex justify-content-between">
                        <span>Amount:</span>
                        <span className="text-primary fw-bold">{Paymentvalue?.amount}</span>
                      </p>
                      <p className="mb-2 d-flex justify-content-between">
                        <span>Due Amount:</span>
                        <span className="text-danger fw-bold">{Paymentvalue?.remaining || "00"}</span>
                      </p>
                      <p className="mb-2 d-flex justify-content-between align-items-center">
                        <span>Amount:</span>
                        <input
                          type="number"
                          className="form-control text-end w-25"
                          value={payAmount}
                          onChange={(e) => setPayAmount(e.target.value)}
                        />
                      </p>
                    </div>
                    <hr />
                    <p className="mb-0 fw-bold fs-5 text-end">
                      Remaining Amount:
                      <span className="text-success fw-bold">
                        {remainingAmount.toFixed(3)}
                      </span>
                    </p>
                  </div>
                </div>

                {/* Modal Footer */}
                <div className="modal-footer border-0 d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={() => setpamentsModel(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-success"
                    disabled={totalPayment <= 0 || totalPayment > dueAmount}
                    onClick={() => onHandlePayCredit(payAmount)}
                  >
                    Pay Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RMReturnListorder;
